import { INoteData } from "../../dto/INoteData";
import { ICourseData } from "../../dto/ICourseData";
import { IRelatedFilter } from "../../redux/modules/document";

// Antal av de tre filtertyperna (Typ, Markeringsfärg, Sökfält) som är aktiva just nu –
// visas som badge på Filtrera-knappen.
export function countActiveFilters(filter: IRelatedFilter): number {
    let count = 0;
    if (filter.types.length > 0) count += filter.types.length;
    if (filter.colors.length > 0) count += filter.colors.length;
    if (filter.query.trim().length > 0) count++;
    return count;
}

export function isRelatedFilterActive(filter: IRelatedFilter): boolean {
    return countActiveFilters(filter) > 0;
}

// OCH-logik: en anteckning måste klara ALLA aktiva filter (inaktiva filter räknas alltid som klarade).
// editingNoteId: id på anteckningen vars note-editor faktiskt är öppen just nu (redux
// editingNoteId, satt av noteInlineEditor.tsx) döljs aldrig av filtret – annars kan en
// nyöppnad editor försvinna direkt om filtret råkar exkludera noten, utan att användaren
// ser att den någonsin öppnades. OBS: inte samma sak som currentNote, som kan peka på en
// anteckning vars editor redan stängts.
export function noteMatchesFilter(note: INoteData, filter: IRelatedFilter, editingNoteId?: string | null): boolean {
    if (editingNoteId && note.id === editingNoteId) return true;
    if (filter.types.length > 0 && !filter.types.includes('notes')) return false;
    if (filter.colors.length > 0 && !filter.colors.includes(note.color)) return false;
    if (filter.query.trim().length > 0) {
        const q = filter.query.trim().toLowerCase();
        const haystack = `${note.text || ''} ${note.title || ''}`.toLowerCase();
        if (!haystack.includes(q)) return false;
    }
    return true;
}

// Kurser har ingen markeringsfärg – färgfiltret påverkar dem aldrig.
export function courseMatchesFilter(course: ICourseData, filter: IRelatedFilter): boolean {
    if (filter.types.length > 0 && !filter.types.includes('courses')) return false;
    if (filter.query.trim().length > 0) {
        const q = filter.query.trim().toLowerCase();
        if (!(course.Text || '').toLowerCase().includes(q)) return false;
    }
    return true;
}
